import { Component, OnInit } from '@angular/core';
import { SearchResult } from '@heda/core-util';
import moment from 'moment';
import { ComponentStateStore } from '@heda/core-util';
import { MessageLog, MessageLogSearchParams } from 'app/pechkin/messagelog/services/messageLog';
import { MessageLogService } from 'app/pechkin/messagelog/services/message-log.service';
import { MessageService } from '@heda/core-hospital-ui';

@Component({
  templateUrl: './message-log-list.component.html',
})
export class MessageLogListComponent implements OnInit {
  public messageLogs: SearchResult<MessageLog>;
  public params: MessageLogSearchParams = new MessageLogSearchParams();
  public loading: boolean;
  private STORE_KEY = 'messagelog-list';

  constructor(
    private messageLogService: MessageLogService,
    private messageService: MessageService,
    private stateStore: ComponentStateStore
  ) {}

  public ngOnInit(): void {
    this.setDefaultParams();

    const state = this.stateStore.pop(this.STORE_KEY);
    if (state) {
      this.params = state.params;
    }

    this.getMessageLogs();
  }

  public getMessageLogs(): void {
    this.stateStore.put(this.STORE_KEY, { params: this.params });
    this.loading = true;

    this.messageLogService.query(this.params).subscribe((resp) => {
      this.loading = false;
      this.messageLogs = resp;
      this.messageLogs.data.forEach(
        (m) => (m['canResend'] = m.status === 'FAILED' && (!m.expiresAt || new Date(m.expiresAt) >= new Date()))
      );
    });
  }

  public setDefaultParams(): void {
    this.params = new MessageLogSearchParams();
    this.params.sort = '-date';
    this.params.dateFrom = moment().startOf('day').toDate();
    this.params.dateTo = moment().endOf('day').toDate();
  }

  public search(): void {
    this.params.offset = 0;
    this.getMessageLogs();
  }

  public resend(log: MessageLog): void {
    log.status = 'RESENT';
    log['canResend'] = false;
    this.messageLogService.resend(log.id).subscribe(() => {
      this.getMessageLogs();
      this.messageService.success('pechkin.int-10.1.resend-success');
    });
  }
}
